import Vue from 'vue';
import Vuex from 'vuex';
import account from './account';
import learning from './learning';
import quiz from './quiz';
import hk from './hk';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    account,
    learning,
    quiz,
    hk,
  },
});
